import { Link, useLocation } from "react-router-dom";
import dd from "../../assets/DD.png";

const DropdownMenu = ({
  title,
  openDropdown,
  toggleDropdown,
  handleLinkClick,
}) => {
  const location = useLocation();

  const isProductActive = location.pathname.startsWith("/products");

  return (
    <div className="relative flex flex-col items-center lg:block">

      <div className="flex items-center gap-1">
        <a
          href="#"
          className={`flex items-center transition ${isProductActive ? "text-[#FF7A00]" : "text-black"
            } hover:text-[#FF7A00]`}
          onClick={(e) => {
            e.preventDefault();
            toggleDropdown(title.toLowerCase());
          }}
        >
          {title}
          <img
            src={dd}
            alt="dropdown"
            className={`h-2 w-3 ml-2 transition ${openDropdown === title.toLowerCase()
                ? "rotate-180"
                : ""
              }`}
          />
        </a>
      </div>

      {openDropdown === title.toLowerCase() && (
        <div className="absolute left-[-550px] mt-4 w-[1200px] bg-white shadow-xl rounded-xl p-6 z-50">

          <div className="grid grid-cols-4 gap-6">

            <div className="border-r pr-4">
              <h3 className="text-xs text-gray-500 uppercase mb-3">LIMS</h3>

              <Link
                to="/products/healthcare"
                onClick={handleLinkClick}
                className={`block transition cursor-pointer ${location.pathname === "/products/healthcare"
                    ? "text-[#FF7A00]"
                    : ""
                  }`}
              >
                <p className="font-medium">
                  Laboratory Information Management System (LIMS / WinLIMS)
                </p>

                <p className="text-xs text-gray-500 mt-1">
                  For standalone labs, hospital labs, and lab chains
                </p>
              </Link>
            </div>


            <div className="border-r pr-4">
              <h3 className="text-xs text-gray-500 uppercase mb-3">QMS</h3>

              <Link
                to="/products/quality-management-system"
                onClick={handleLinkClick}
                className={`block transition cursor-pointer ${location.pathname === "/products/quality-management-system"
                    ? "text-[#FF7A00]"
                    : ""
                  }`}
              >
                <p className="font-medium">
                  Quality Control System (QMS)
                </p>

                <p className="text-xs text-gray-500 mt-1">
                  Manages QC processes, audits, and compliance
                </p>
              </Link>
            </div>


            <div className="border-r pr-4">
              <h3 className="text-xs text-gray-500 uppercase mb-3">
                Inventory
              </h3>

              <Link
                to="/products/inventory"
                onClick={handleLinkClick}
                className={`block transition cursor-pointer ${location.pathname === "/products/inventory"
                    ? "text-[#FF7A00]"
                    : ""
                  }`}
              >
                <p className="font-medium">
                  Inventory Management System
                </p>

                <p className="text-xs text-gray-500 mt-1">
                  Tracks lab consumables, suppliers, and stock
                </p>
              </Link>
            </div>

            <div>
              <h3 className="text-xs text-gray-500 uppercase mb-3">
                Veterinary
              </h3>

              <Link
                to="/products/veterinary"
                onClick={handleLinkClick}
                className={`block transition cursor-pointer ${location.pathname === "/products/veterinary"
                    ? "text-[#FF7A00]"
                    : ""
                  }`}
              >
                <p className="font-medium">
                  Veterinary LIMS
                </p>

                <p className="text-xs text-gray-500 mt-1">
                  Specialized system for veterinary laboratories
                </p>
              </Link>
            </div>

          </div>
        </div>
      )}
    </div>
  );
};

export default DropdownMenu;